import React from 'react';
import ApplicationsHeaderButton from './ApplicationsHeaderButton';
import ApplicationsListHeader from './ApplicationsListHeader';
import JobBoardPagination from '../../../JobBoard/JobBoardPagination';
import ApplicationRow from './ApplicationRow';
import EmptyApplication from './EmptyApplication';

const ApplicationsListForm = ({
  applies,
  selectedTab,
  onRowClick,
  selectedIds,
  onCheckboxChange,
  onSelectAll,
  onDelete,
  isAllSelected,
  onFilterChange,
  filterPeriod,
  statusFilter,
  onStatusChange,
  current,
  totalPages,
  onPageChange,
  $isMobile,
  onDownloadCertificate,
  isCertificateDownloading,
}) => {
  return (
    <div className='flex flex-col w-full items-start p-0 tabletH:px-4 tabletH:py-6 bg-transparent tabletH:bg-grayscale-gray00 rounded-[15px]'>
      <ApplicationsHeaderButton
        onDelete={onDelete}
        hasSelected={selectedIds.length > 0}
        selectedTab={selectedTab}
        onFilterChange={onFilterChange}
        filterPeriod={filterPeriod}
        $isMobile={$isMobile}
        isAllSelected={isAllSelected}
        onSelectAll={onSelectAll}
        statusFilter={statusFilter}
        onStatusChange={onStatusChange}
        onDownloadCertificate={onDownloadCertificate}
        isCertificateDownloading={isCertificateDownloading}
      />
      {!$isMobile && (
        <ApplicationsListHeader
          selectedTab={selectedTab}
          isAllSelected={isAllSelected}
          onSelectAll={onSelectAll}
        />
      )}
      {applies.length === 0 ? (
        <EmptyApplication selectedTab={selectedTab} />
      ) : (
        <div className='flex flex-col w-full pb-10 gap-2'>
          {applies.map((apply) => {
            const currentId =
              selectedTab === 'saved' ? apply.jobPostId : apply.jobApplyId;
            return (
              <ApplicationRow
                key={currentId}
                data={apply}
                selectedTab={selectedTab}
                onClick={() => onRowClick(apply)}
                checked={selectedIds.includes(currentId)}
                onCheckboxChange={() => onCheckboxChange(currentId)}
                $isMobile={$isMobile}
              />
            );
          })}
        </div>
      )}
      <JobBoardPagination
        current={current}
        totalPages={totalPages}
        onPageChange={onPageChange}
        isMyPage
      />
    </div>
  );
};

export default ApplicationsListForm;
